import styles from "./Landing.module.scss";
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { useState } from "react";
import axios from "../../config/axios";

//importing components
import Layout from "../../Components/Layout/Layout";
import {
  Button,
  Checkbox,
  Col,
  Collapse,
  Form,
  Input,
  Row,
  Select,
  message,
} from "antd";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { FaUsers, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import { IoIosArrowDropright } from "react-icons/io";
import { DownCircleFilled } from "@ant-design/icons";

//importing utils
import { cities } from "../../utils/data";
import PreOrderNowModal from "../../Components/PreOrderNowModal/PreOrderNowModal";
import ContactUs from "../../Components/ContactUs/ContactUs";
import HeroSlider from "../../Components/HeroSlider/HeroSlider";
import Features from "../../Components/Features/Features";

const Landing = () => {
  const [form] = Form.useForm();
  const { Panel } = Collapse;

  const [captcha, setCaptcha] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPreOrderNowModal, setShowPreOrderNowModal] = useState(false);

  //defining onReCaptchaChange function
  function onReCaptchaChange(value) {
    console.log("Captcha value:", value);
    setCaptcha(value);
  }

  //calling subscribe to newsletter api
  const handleSubscribeToNewsletter = (values) => {
    // console.log(values);
    setLoading(true);
    axios.post("/newsletter/subscribe", values).then((response) => {
      setLoading(false);
      message.success("Registered successfully!");
    });
  };

  return (
    <Layout>
      {/* Hero Slider */}
      {/*<HeroSlider />*/}

      <section className={styles.why + " container"}>
        <div className={styles.why__left}>
          <span>WHY</span>
          <p>DESI FRESH</p>
          <Link to="/our-story?step=1" style={{ width: "100%" }}>
            <button style={{ width: "100%" }}>
              <FaUsers size={20} color={"var(--color-light)"} />
              <span>Our Story</span>
              <BsFillArrowRightCircleFill
                color={"var(--color-orange)"}
                size={20}
                style={{ marginLeft: "auto" }}
              />
            </button>
          </Link>
        </div>
        <div className={styles.why__right}>
          <p>
            At Desi Fresh, we believe in doing things the right way. Our
            decisions are guided by{" "}
            <span style={{ color: "var(--color-primary)" }}>
              100% authentic desi foods
            </span>{" "}
            for a fresh, delicious, nutritious, hygienic, and unparalleled
            customer experience. Everything we offer at Desi Fresh – from the
            freshest of flavors to donating a portion of our proceeds to the
            poor – is t with the community spirit in mind, resulting in{" "}
            <span style={{ color: "var(--color-primary)" }}>
              healthy food, a happy planet, and the healthiest, happiest you.
            </span>
          </p>
          <div>
            <span>We are Desi Fresh</span>
            <span> - The original quality made for you</span>
          </div>
        </div>
      </section>

      <section className={styles.qq}>
        <div className={styles.qq__body + " container"}>
          <div className={styles.qq__left}>
            <span className={styles.qq__left__lt}>
              Authentic . Hygienic . High Quality
            </span>
            <span className={styles.qq__left__st}>
              Checked . Verified . Approved
            </span>
            <div className={styles.qq__left__box}>
              <span>Enjoy the Taste</span>
              <span>Today, Tomorrow and Everyday</span>
            </div>
          </div>
          <div className={styles.qq__right}>
            <img src="/qc.svg" alt="" />
          </div>
        </div>
      </section>

      <section className={styles.founder + " container"}>
        <strong style={{ fontSize: "3rem" }}>Our Founders</strong>
        <ul>
          <li>
            <div className={styles.founder__img_wrapper}>
              <img src="/dr-preeti-singh.png" alt="" />
              <ins>Biography</ins>
            </div>
            <em>
              Dr. Preeti Singh,{" "}
              <span style={{ color: "var(--color-grey)" }}>Ph.D</span>
            </em>
            <p>Founder & CEO</p>
            <div>
              <FaLinkedinIn size={15} />
              <IoMail size={15} />
              <FaTwitter size={15} />
            </div>
          </li>

          <li>
            <div className={styles.founder__img_wrapper}>
              <img src="/dr-ali-abas-wani.png" alt="" />
              <ins>Biography</ins>
            </div>
            <em>
              Dr. Ali Abas Wani,{" "}
              <span style={{ color: "var(--color-grey)" }}>Ph.D, MBA</span>
            </em>
            <p>Co - Founder</p>
            <div>
              <FaLinkedinIn size={15} />
              <IoMail size={15} />
              <FaTwitter size={15} />
            </div>
          </li>
        </ul>
      </section>

      <section className={styles.discount}>
        <div className={styles.discount__body}>
          <div className={styles.discount__body__left}>
            <span
              style={{
                color: "var(--color-light)",
                fontSize: window.innerWidth <= 768 ? "2rem" : "2.6rem",
                fontWeight: 600,
              }}
            >
              Limited Offer
            </span>
            <div style={{ display: "flex" }}>
              <span
                style={{
                  fontSize: window.innerWidth <= 768 ? "16rem" : "26rem",
                  color: "var(--color-light)",
                  fontWeight: 700,
                  lineHeight: 0.6,
                }}
              >
                5
              </span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginRight: window.innerWidth <= 768 ? "2rem" : 0,
                }}
              >
                <span
                  style={{
                    fontSize: window.innerWidth <= 768 ? "4rem" : "6rem",
                    color: "var(--color-light)",
                    fontWeight: 700,
                    lineHeight: 1,
                  }}
                >
                  %
                </span>
                <span
                  style={{
                    fontSize: window.innerWidth <= 768 ? "4rem" : "6rem",
                    color: "var(--color-light)",
                    fontWeight: 700,
                    lineHeight: 1,
                  }}
                >
                  Discount
                </span>
                <span
                  style={{
                    fontSize: window.innerWidth <= 768 ? "3rem" : "5rem",
                    color: "var(--color-light)",
                    fontWeight: 700,
                    lineHeight: 1,
                  }}
                >
                  On pre orders
                </span>
              </div>
            </div>
            <button
              className={styles.pre_order}
              onClick={() => setShowPreOrderNowModal(true)}
            >
              Pre Order Now
              <IoIosArrowDropright size={20} />
            </button>
          </div>
          <div className={styles.discount__body__right}>
            <span
              style={{
                fontSize: "2.5rem",
                color: "var(--color-primary)",
                fontWeight: 700,
                marginTop: ".5rem",
              }}
            >
              We check to bring the best for you
            </span>
            <ul>
              <li>
                <img src="/discount_1.png" alt="" />
                <span>Hygiene</span>
              </li>
              <li>
                <img src="/discount_2.png" alt="" />
                <span>Quality</span>
              </li>
              <li>
                <img src="/discount_3.png" alt="" />
                <span>Food Safety</span>
              </li>
              <li>
                <img src="/discount_4.png" alt="" />
                <span>Food fraud prevention</span>
              </li>
            </ul>
          </div>
        </div>
        <button className={styles.read_more}>
          <span>Read More</span>
        </button>
      </section>

      <section className={styles.van}>
        <span
          style={{
            fontSize: "5rem",
            fontWeight: "700",
            color: "var(--color-primary)",
          }}
        >
          Hey Desi Guys!
        </span>
        <img src="/cargo-van.png" alt="" className={styles.van__image} />
        <div className={styles.enjoy}>
          <span
            style={{
              fontSize: window.innerWidth <= 768 ? "2rem" : "3rem",
              color: "var(--color-primary)",
              fontWeight: 700,
            }}
          >
            NOW{" "}
            <span style={{ letterSpacing: 8, padding: "0 1rem" }}>ENJOY</span>{" "}
            THE EXPERIENCE
          </span>
          <img src="/u-vector.svg" alt="" />
        </div>
        <span
          style={{
            fontSize: "1.6rem",
            textDecoration: "underline",
            color: "var(--color-primary)",
            padding: "0 2rem",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          We are starting in Munich, let us know where you'd like us to be!
        </span>
      </section>

      <section className={styles.faq}>
        <div className={styles.faq__body + " container"}>
          <div className={styles.faq__body__title_box}>
            <img src="/icon/faq.svg" alt="" />
            <span>Frequently Asked Questions (FAQ)</span>
          </div>
          <span
            style={{
              marginTop: "1rem",
              color: "var(--color-light)",
              maxWidth: "700px",
              textAlign: "center",
              fontSize: "1.6rem",
            }}
          >
            Here are the answers to your most common questions. <br />
            Can’t find the answer? Message us your question via{" "}
            <span
              style={{
                color: "var(--color-yellow)",
                textDecoration: "underline",
              }}
            >
              Contact us
            </span>{" "}
          </span>

          <Collapse
            bordered={false}
            defaultActiveKey={["1"]}
            expandIcon={({ isActive }) => (
              <DownCircleFilled
                style={{ fontSize: 16 }}
                rotate={isActive ? 180 : 0}
              />
            )}
            expandIconPosition="end"
            className="site-collapse-custom-collapse"
            style={{ width: "100%", marginTop: "4rem" }}
            accordion
          >
            <Panel
              header="What is Desi Fresh?"
              key="1"
              className="site-collapse-custom-panel"
            >
              <p>
                Desi Fresh is a an 100% authentic store for Indian, Bangladeshi,
                Srilankan and other Asian immigrant expats to enjoy the
                nutritious, traditional and healthy food grocery you love in
                your home countries. Our promise to you is authentic, high
                quality customer experience, and a promise of giving back means
                we give back to the poor with every purchase you make. Go Fresh
                employs a unique food safety and traceability system that
                guarantees transparency, quality, and authenticity for every
                product on our shelves. We are Desi Fresh, the original quality
                made for you.
              </p>
            </Panel>

            <Panel
              header="What are the areas where Desi Fresh Delivers?"
              key="2"
              className="site-collapse-custom-panel"
            >
              <p>
                In our first phase, we are delivering throughout Germany through
                delivery partners DHL, UPS, DPD, & Hermes. At the same time, in
                Munich we are delivering through our own delivery service. This
                service would be expanded in the phased manner to the other
                cities (Stuttgart, Cologne, Hamburg, Berlin, Frankfurt,
                Nürnberg, Dusseldorf etc. in Germany.)
              </p>
            </Panel>

            <Panel
              header="Will I get the delivery the same day?"
              key="3"
              className="site-collapse-custom-panel"
            >
              <p>
                If you are located in Munich, we would be able to deliver the
                same day delivery on Wednesday to Saturday. We will expand the
                same day delivery to other cities in a phased manner. At this
                moment, we deliver within 2 days to the rest of Germany using
                our partner delivery services.
              </p>
            </Panel>

            <Panel
              header="What are the shipping charges like?"
              key="4"
              className="site-collapse-custom-panel"
            >
              <p>
                Same day delivery for the Munich region costs 1.80 Euros.
                Standard delivery is free of cost and can be delivered within
                24-48 Hours at a basket price of 50 Euros. The delivery options
                for customers living outside Germany will be available in the
                near future. The customers from greater Munich area can also opt
                for cash on delivery or pay through invoice.
              </p>
            </Panel>

            <Panel
              header="Can I schedule the delivery of my Items?"
              key="5"
              className="site-collapse-custom-panel"
            >
              <p>
                Yes, the delivery can be scheduled as per your convenient time.
                When you place an order, please add a note that you need the
                delivery at a specific time slot. We will try our best to
                arrange a delivery at your preferred delivery time slot.
                However, our priority is to deliver your order at the earliest.
              </p>
            </Panel>

            <Panel
              header="Can I track the order?"
              key="6"
              className="site-collapse-custom-panel"
            >
              <p>
                Once the order is confirmed, you will receive the tracking
                number via email. The order can be tracked using the tracing
                number provided per mail. If you place your order during the
                weekend or a public holiday, your order and tracking will be
                sent out during the next working day, so you can allow
                additional day to receive your tracking details.
              </p>
            </Panel>

            <Panel
              header="What are the payment methods available?"
              key="7"
              className="site-collapse-custom-panel"
            >
              <p>
                We accept all major credit cards and there is also an option to
                make payments with sofort banking. All our transactions are
                highly secured by the service providers. We also accept cash on
                Delivery in the Greater Munich area; this service will be
                periodically extended to the other cities during our expansion
                phase.
              </p>
            </Panel>

            <Panel
              header="How can I become a member of the Desi Family Card?"
              key="8"
              className="site-collapse-custom-panel"
            >
              <p>
                Desi Family card has several advantages from surprise offers to
                community clubs and events. To become a member, please register
                on the Desi Family webpage. More details are coming soon.
              </p>
            </Panel>

            <Panel
              header="How can I become a Desi Fresh supplier?"
              key="9"
              className="site-collapse-custom-panel"
            >
              <p>
                We would love to do business with anyone who demands high
                quality food standards, sustainable relationships, and superb
                customer satisfaction. If you are convinced with our vision and
                our shared values of quality, authenticity, and Desi, please
                sends us your information on our Contact Us page.
              </p>
            </Panel>
          </Collapse>
        </div>
      </section>

      <ContactUs />

      <section className={styles.register}>
        <div className={styles.register__body + " container"}>
          <strong style={{ color: "var(--color-primary)" }}>
            Be the first to try our products & services{" "}
          </strong>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubscribeToNewsletter}
          >
            <Row gutter={[50, 5]}>
              <Col sm={6} xs={24}>
                <Form.Item label="" required name={"first_name"}>
                  <Input type={"text"} placeholder="First Name" />
                </Form.Item>
              </Col>

              <Col sm={6} xs={24}>
                <Form.Item label="" required name={"last_name"}>
                  <Input type={"text"} placeholder="Last Name" />
                </Form.Item>
              </Col>

              <Col sm={6} xs={24}>
                <Form.Item label="" required name={"email"}>
                  <Input type={"email"} placeholder="Email Address" />
                </Form.Item>
              </Col>

              <Col sm={6} xs={24}>
                <Form.Item label="" required name={"city"}>
                  <Select placeholder="Select City">
                    {cities.map((city, index) => {
                      return (
                        <Select.Option key={index} value={city.name}>
                          {city.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>

              <Col sm={24}>
                <Form.Item label="" required>
                  <Checkbox>
                    Yes, I would like to recieve the offers and updates by
                    e-amil and agree to the processing of my personal data in
                    accordance with the Desi Fresh{" "}
                    <Link
                      to="/"
                      style={{
                        color: "var(--color-light)",
                        textDecoration: "underline",
                      }}
                    >
                      Data Protection Policy
                    </Link>
                    . You can{" "}
                    <Link
                      to="/"
                      style={{
                        color: "var(--color-light)",
                        textDecoration: "underline",
                      }}
                    >
                      unsubscribe
                    </Link>{" "}
                    anytime you wish to not recieve any information about
                    products and promotions of Desi Fresh.
                    <br />
                    For more information, please see our{" "}
                    <Link
                      to="/"
                      style={{
                        color: "var(--color-light)",
                        textDecoration: "underline",
                      }}
                    >
                      privacy policy{" "}
                    </Link>
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <br />
          <ReCAPTCHA
            sitekey="6LdZLO8fAAAAAF74CKt5Y_CTuaolPyWhkNjlAxyJ"
            onChange={onReCaptchaChange}
          />
          <Button
            style={{ marginTop: "2rem", padding: "0 2rem" }}
            type="primary"
            htmlType="submit"
            onClick={() => form.submit()}
            loading={loading}
            disabled={captcha ? false : true}
          >
            Subscribe
          </Button>
        </div>
      </section>

      {/* landing 5 column featured section */}
      <Features />

      {/* render pre book now modal on button click */}
      {showPreOrderNowModal && (
        <PreOrderNowModal
          showModal={showPreOrderNowModal}
          setShowModal={setShowPreOrderNowModal}
        />
      )}
    </Layout>
  );
};

export default Landing;
